<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        DANH SÁCH PHIẾU ĐIỀU TOUR
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên tour" prop="tour_id">
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_tour"
                        :fetch-suggestions="querySearch"
                        placeholder="Nhập tên tour để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        @change="handleSelect"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten_tour }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      label="Hướng dẫn viên"
                      prop="huong_dan_vien_ids"
                    >
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ho_ten_Hdv"
                        :fetch-suggestions="querySearchHdv"
                        placeholder="Nhập tên hướng dẫn viên để tìm kiếm"
                        :trigger-on-focus="false"
                        @select="handleSelectHdv"
                        @change="handleSelectHdv"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ho_ten.ho_ten }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      label="Thời gian bắt đầu"
                      prop="thoi_gian_bat_dau"
                      :error="fn_compareTime()"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_gian_bat_dau
                        "
                        placeholder="Chọn ngày bắt đầu"
                        clearable
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      label="Thời gian kết thúc"
                      prop="thoi_gian_ket_thuc"
                      :error="fn_compareTime()"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_gian_ket_thuc
                        "
                        placeholder="Chọn ngày kết thúc"
                        clearable
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                v-if="aRole('TourAgent')"
                plain
                >{{ aLang.c_create }}</el-button
              >
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column prop="tour_id" label="Tên tour" min-width="200">
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false"
                >{{ scope.row.ten_tour }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="ten_huong_dan_vien"
            label="Hướng dẫn viên"
            width="200"
          ></el-table-column>

          <el-table-column
            prop="thoi_gian_bat_dau"
            :sortable="mData.tableRules.allowSorting"
            label="Thời gian bắt đầu"
            :formatter="fn_formatterDatetime"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="thoi_gian_ket_thuc"
            :sortable="mData.tableRules.allowSorting"
            label="Thời gian kết thúc"
            :formatter="fn_formatterDatetime"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
                v-if="aRole('TourAgent')"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('TourAgent')"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import PhieuDieuTourModel from "./PhieuDieuTourModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "PhieuDieuTour", //requied
        tableRules: MethodService.copyObject(PhieuDieuTourModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: [],
          listTour: [],
          listHuongDanVien: [],
          listFindTour: [],
          listFindHuongDanVien: [],
          validErrorTime: false,
        },
      },
      ten_tour: "",
      ho_ten_Hdv: "",
    };
  },

  methods: {
    async querySearch(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }

      var q1 = queryString
        .replace("*", "\\\*")
        .replace("$", "\\\$")
        .replace("%", "\\\*")
        .replace("[", "\\\[")
        .replace("]", "\\\]")
        .replace("^", "\\\^");
      let res = await mushroom.tour.listAsync({
        limit: 1000,
        filters: `ten_tour:regex_i:${q1}`,
      });

      var results = queryString
        ? res.result.filter((item) =>
            item.ten_tour.toLowerCase().includes(queryString.toLowerCase())
          )
        : res.result;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelect(item) {
      this.mData.tableRules.dataSearch.value.tour_id = item.id;
      this.ten_tour = item.ten_tour;
    },
    async querySearchHdv(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }

      var q1 = queryString
        .replace("*", "\\\*")
        .replace("$", "\\\$")
        .replace("%", "\\\*")
        .replace("[", "\\\[")
        .replace("]", "\\\]")
        .replace("^", "\\\^");
      let res = await mushroom.huong_dan_vien.listAsync({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${q1}`,
      });

      var results = queryString
        ? res.result.filter((item) =>
            item.ho_ten.ho_ten.toLowerCase().includes(queryString.toLowerCase())
          )
        : res.result;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectHdv(item) {
      this.mData.tableRules.dataSearch.value.huong_dan_vien_ids = item.id;
      this.ho_ten_Hdv = item.ho_ten.ho_ten;
    },
    //get list table
    async fn_initTable() {
      try {
        let dataFilter = {
          filters: this.mData.tableRules.filters,
        };

        if (this.mData.tableRules.allowPaging) {
          dataFilter.limit = this.mData.tableRules.limit;
          dataFilter.offset = this.mData.tableRules.offset;
        }
        if (this.mData.tableRules.allowSorting) {
          dataFilter.sort = this.mData.tableRules.sort;
        }

        if (this.mData.tableRules.showUrl) {
          this.$router
            .replace({
              name: "Admin-" + this.mData.moduleName + "-list",
              query: {
                limit: this.mData.tableRules.limit,
                page: this.mData.tableRules.page,
                sort: this.mData.tableRules.sort,
                filters: this.mData.tableRules.filters,
                showFormSearch: this.mData.tableRules.showFormSearch,
              },
            })
            .catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                throw err;
              }
            });
        }

        let res = await mushroom.phieu_dieu_tour.listAsync(dataFilter);

        // get tour name, huong dan vien name
        //helper - new
        let resData = res.result;
        let tourIds = [];
        let listHuongDanVienIds = [];

        tourIds = MethodService.findListItemDifferent(resData, "tour_id");

        $.each(resData, (index, item) => {
          if (item.huong_dan_vien_ids) {
            listHuongDanVienIds = listHuongDanVienIds.concat(
              item.huong_dan_vien_ids
            );
          }
        });

        let huongDanVienIds =
          MethodService.findListItemDifferent(listHuongDanVienIds);

        let reqTourApi = mushroom.tour.listAsync({
          limit: tourIds.length,
          filters: "id:in:" + tourIds.join(","),
        });
        let reqHuongDanVienApi = mushroom.huong_dan_vien.listAsync({
          limit: huongDanVienIds.length,
          filters: "id:in:" + huongDanVienIds.join(","),
        });

        let resTourApi = await reqTourApi;
        let resHuongDanVienApi = await reqHuongDanVienApi;

        this.mData.dataDefault.listTour = resTourApi.result;
        this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;

        $.each(resData, (index, item) => {
          let tenTour = this.mData.dataDefault.listTour.find((element) => {
            return element.id == item.tour_id;
          });
          if (tenTour) {
            item.ten_tour = tenTour.ten_tour;
          } else {
            item.ten_tour = "";
          }

          let ten_hdv = "";
          $.each(item.huong_dan_vien_ids, (indexData, itemData) => {
            let tenHDV = this.mData.dataDefault.listHuongDanVien.find(
              (element) => {
                return element.id == itemData;
              }
            );
            if (tenHDV) {
              ten_hdv += tenHDV.ho_ten.ho_ten + ", ";
            } else {
              ten_hdv += "";
            }
          });
          item.ten_huong_dan_vien = ten_hdv.slice(0, -2);
          item.ten_huong_dan_vien +=
            " (" +
            item.huong_dan_vien_ids.length +
            "/" +
            (item.huong_dan_vien_ids.length +
              item.huong_dan_vien_cho_xac_nhan_ids.length) +
            ")";
        });

        //end get name
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = res.meta.total;
        this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
        if (
          this.mData.tableRules.offset == res.meta.total &&
          this.mData.tableRules.offset != 0
        ) {
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.page = 1;
          await this.fn_initTable();
        }
      } finally {
        MethodService.stopLadda();
      }
    },

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            var flag = true;
            if (row.huong_dan_vien_ids && row.huong_dan_vien_ids.length > 0) {
              toastr.error(
                "Không thể xóa phiếu điều tour đã có hướng dẫn viên đã xác nhận"
              );
              flag = false;
            }
            if (flag) {
              this.fn_delete(row.id);
            }
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      try {
        let { result } = await mushroom.phieu_dieu_tour.deleteAsync({ id: id });
        if (result === 1) {
          toastr.success("Xóa phiếu điều tour thành công");
          this.fn_initTable();
        }
      } catch (error) {
        toastr.error("Xóa phiếu điều tour thất bại");
      }
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          await this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router
        .push({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: query,
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },

    async fn_findTour(query) {
      query = query.trim();
      if (!query) {
        return;
      }

      var q1 = query
        .replace("*", "\\\*")
        .replace("$", "\\\$")
        .replace("%", "\\\*")
        .replace("[", "\\\[")
        .replace("]", "\\\]")
        .replace("^", "\\\^");
      let res = await mushroom.tour.listAsync({
        limit: 1000,
        filters: `ten_tour:regex_i:${q1}`,
      });
      this.mData.dataDefault.listFindTour = res.result;
    },

    async fn_findHuongDanVien(query) {
      query = query.trim();
      if (!query) {
        return;
      }
      let res = await mushroom.huong_dan_vien.listAsync({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${query}`,
      });
      this.mData.dataDefault.listFindHuongDanVien = res.result;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach((item) => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }

      //add value to form search
      if (this.mData.tableRules.dataSearch.value.tour_id) {
        let res = await mushroom.tour.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.tour_id,
        });
        this.mData.dataDefault.listFindTour.push(res.result);
        this.ten_tour = res.result.ten_tour;
        // this.querySearch(this.ten_tour);
        // this.handleSelect(item);
      }
      if (this.mData.tableRules.dataSearch.value.huong_dan_vien_ids) {
        let resHDV = await mushroom.huong_dan_vien.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.huong_dan_vien_ids,
        });
        this.mData.dataDefault.listFindHuongDanVien.push(resHDV.result);
        this.ho_ten_Hdv = resHDV.result.ho_ten.ho_ten;
      }
    },

    fn_compareTime() {
      let timeStart = this.mData.tableRules.dataSearch.value.thoi_gian_bat_dau;
      let timeEnd = this.mData.tableRules.dataSearch.value.thoi_gian_ket_thuc;

      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() > time2.getTime()) {
          this.mData.dataDefault.validErrorTime = true;
          return LanguageService.lang.valid_compareTime;
        }
      } else {
        this.mData.dataDefault.validErrorTime = false;
        return "";
      }
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>

<style lang="scss">
.el-autocomplete,
.el-date-editor.el-input {
  width: 100%;
}
.el-select-dropdown__wrap {
  // max-width: 335px;
}
</style>
